import { Descriptions } from 'antd';
import React from 'react';
import { ApplicantUserContactInformation } from '../../../../generated';
import { CountryView } from '../../../shared/country-view/country-view';
import { ProfileHeaderContainer } from './profile-header.container';

const TITLE = 'Contact Details';

interface ContactViewProps {
  contactInformation: ApplicantUserContactInformation;
  onEdit: () => void;
}

export const ApplicantProfileContactView: React.FC<ContactViewProps> = ({ contactInformation, onEdit: onEditToggle }) => {
  const phoneTypeDisplayMap = {
    home: 'Home',
    work: 'Work',
    cell: 'Cell',
    other: 'Other'
  };
  
  const primaryPhoneType = contactInformation?.phone?.find(p => p?.phoneNumber === contactInformation.primaryPhone);

  const mapPhoneTypeToDisplay = (type: string | null | undefined): string => phoneTypeDisplayMap[type as keyof typeof phoneTypeDisplayMap] || 'Other';

  return (
    <div>
      <ProfileHeaderContainer title={TITLE} onEdit={onEditToggle} />
      <Descriptions title={undefined} layout="vertical" size="small" column={1} className="w-[450px]">
        <Descriptions.Item label="Primary Phone">{contactInformation.primaryPhone} ({primaryPhoneType ? mapPhoneTypeToDisplay(primaryPhoneType.phoneType) : 'Other'})</Descriptions.Item>
        <br />
        {contactInformation?.phone && contactInformation?.phone?.length > 0 ? (
          contactInformation?.phone.map((p) =>
            p && p.phoneNumber !== contactInformation.primaryPhone
          ? (
              <React.Fragment key={p.phoneNumber}>
                <Descriptions.Item label="Phone Type">{mapPhoneTypeToDisplay(p.phoneType)}</Descriptions.Item>
                <Descriptions.Item label="Phone Number">{p.phoneNumber}</Descriptions.Item>
                <br />
              </React.Fragment>
            ) : null
          )
        ) : (
          <Descriptions.Item>No phone information available</Descriptions.Item>
        )}

        <Descriptions.Item label="Address of Residence">
          {contactInformation.address?.streetAddressLine1}
          <br />
          {contactInformation.address?.streetAddressLine2 && (
            <>
              {contactInformation.address?.streetAddressLine2} <br />
            </>
          )}
          {contactInformation.address?.city && `${contactInformation.address?.city}, `}{' '}
          {contactInformation.address?.stateOrProvince && `${contactInformation.address?.stateOrProvince}, `}
          {contactInformation.address?.zipOrPostalCode && (
            <>
              {contactInformation.address?.zipOrPostalCode} <br />
            </>
          )}
        </Descriptions.Item>
      </Descriptions>
      <div style={{}}>
        <CountryView label="" countryCode={contactInformation.address?.country ?? ''} />
      </div>
    </div>
  );
};
